import GetCalendarFoldersResponse from 'owa-service/lib/contract/GetCalendarFoldersResponse';
import { SessionData } from 'owa-service/lib/getSessionData';

let responseFromSessionData: GetCalendarFoldersResponse;

export function stashCalendarFoldersFromSessionData(
    sessionData: SessionData & { getCalendarFolders: GetCalendarFoldersResponse }
): SessionData {
    const { getCalendarFolders } = sessionData;
    responseFromSessionData = getCalendarFolders;
    return sessionData;
}

export function getCalendarFoldersFromSessionData(): GetCalendarFoldersResponse {
    let response = responseFromSessionData;
    responseFromSessionData = undefined;
    return response;
}
